<template>
  <div class="bradgall">
    <EditComp
      :Platform="Platform"
      :isShowContentEdit="isShowContentEdit"
      :useMixinTypeA="false"
      @Updatepreview="PopulatePreview"
      @DisableEdit="CancelEdit"
      :parentIndex="0"
    />

    <el-dialog title="" :visible.sync="isShowCampaign" width="50%">
      <template slot="title"
        ><h3 class="fsize16 Add mb-0 Products text-white">
          Add Details
        </h3></template
      >
      <div>
        <div class="">
          <div class="relative">
            <small class="fsize12 bg-white font-medium text-dark">Title </small>
            <el-input
              v-model="title"
              placeholder="Enter..."
              class="rounded-xl mt-2"
            />
          </div>

          <div class="relative mt-4">
            <small class="fsize12 font-medium bg-white text-dark"
              >Subtitle</small
            >
            <el-input
              v-model="subtitle"
              type="text"
              placeholder="Enter..."
              class="rounded-xl mt-2"
            />
          </div>

          <div class="relative mt-4">
            <small class="fsize12 font-medium bg-white text-dark"
              >Caption</small
            >
            <el-input
              v-model="description"
              type="textarea"
              placeholder="Enter..."
              class="rounded-xl mt-2"
            />
          </div>
        </div>

        <div class="mt-6">
          <small class="fsize12 bg-white font-medium text-dark"
            >Select Media</small
          >
          <div class="grid grid-cols-8 gap-2 mt-4">
            <div
              class="img_wrap"
              v-for="(item, index) in mediaCollection"
              :key="('item-', +index)"
            >
              <img
                :src="item.img"
                alt="image"
                class="w-full object-cover rounded-4px h-72px cursor-pointer"
              />

              <div
                class="img__description_layer flex justify-center items-center rounded-4px h-72px"
              >
                <feather-icon
                  icon="CheckIcon"
                  svgClasses="w-8 h-8"
                  class="text-success font-semibold"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="mt-6">
          <small class="fsize12 bg-white font-medium text-dark"
            >Select Layout</small
          >
          <div class="grid grid-cols-8 gap-2 mt-4">
            <div
              class="img_wrap"
              v-for="(item, index) in imgCollection"
              :key="('item-', +index)"
              @click="isShowImage = item"
            >
              <img
                :src="item.img"
                alt="image"
                class="w-full object-cover rounded-4px h-72px cursor-pointer"
              />

              <div v-if="isShowImage.img == item.img" class="previewselect">
                <feather-icon
                  icon="CheckIcon"
                  svgClasses="w-8 h-8"
                  class="text-success flex font-semibold"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-end gap-4">
          <vs-button
            type="primary"
            class="bg-primary cursor-pointer mt-8 px-8 py-3"
            @click="updateDetails"
            >Update</vs-button
          >
          <vs-button
            type="secondary"
            class="cursor-pointer mt-8 px-8 py-3 bg-secondary"
            >Cancel</vs-button
          >
        </div>
      </div>
    </el-dialog>
    <el-dialog
      width="30%"
      title=""
      :visible.sync="isshowCampaignPopup"
      class="ishidePopup"
    >
      <template slot="title"
        ><h3 class="text-xl mb-0 Add Products text-white">
          Add Campaign
        </h3></template
      >
      <div>
        <div class="px-2">
          <div>
            <p class="fsize14 font-semibold text-4f4f4f mb-0">Add Campaign</p>
            <el-select
              v-model="selectedCampaign"
              class="mt-2"
              placeholder="Enter.."
            >
              <el-option
                v-for="item in Campaignoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                class="mt-2 w-full"
              >
              </el-option>
            </el-select>
          </div>

          <div class="grid grid-cols-2 gap-4 justify-center mt-8 items-center">
            <vs-button
              color="primary"
              type="border"
              class="w-full font-normal lg:py-3 fsize14 md:py-3 py-2 px-4 sm-fsize14"
              @click="isshowCampaignPopup = false"
            >
              Cancel
            </vs-button>

            <vs-button
              class="w-full border-0 text-white font-normal lg:py-3 fsize14 md:py-3 py-2 px-4 sm-fsize14"
            >
              Start a Campaign
            </vs-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <div v-if="NoUpcoming">No Upcoming event</div>
    <div v-else>
      <el-card class="elcard-p0px relative rounded-10px px-6 py-4 cols-span-6">
        <div class="flex justify-between items-center">
          <div class="flex justify-between items-center">
            <h2 class="text-dark fsize14 font-semibold flex items-center">
              BR<span class="text-brcolor">AI</span>NED's AI Powered Posts
            </h2>
            <feather-icon
              icon="InfoIcon"
              class="ml-1 text-grey flex"
              svgClasses="w-5 h-5"
            />
          </div>

          <div
            class="flex justify-center bg-light-primary rounded-full items-center w-10 h-10"
          >
            <feather-icon
              icon="ChevronRightIcon"
              svgClasses="w-5 h-5"
              class="text-primary font-semibold flex"
            />
          </div>
        </div>
        <div class="mt-4">
          <h2
            class="font-semibold flex justify-between items-center text-dark fsize20"
          >
            {{ eventsCard[0] ? eventsCard[0].title : "" }}
          </h2>
          <p class="mt-2 mb-4 font-medium fsize14 text-dark lineclamp-2">
            {{ eventsCard[0] ? eventsCard[0].subtitle : "" }}
          </p>
        </div>

        <div>
          <div class="bg-white grid grid-cols-2 gap-4">
            <div>
              <div :class="Posts ? `img_wrap_insta` : `img_wrap`">
                <div v-if="Posts">
                  <canvas
                    :style="{ pointerEvents: `none` }"
                    id="my-canvas1"
                  ></canvas>
                </div>

                <div v-else>
                  <svg
                    viewBox="0 0 1080 1080"
                    v-html="this.isShowImage.svg"
                    class="w-full object-cover rounded-4px h-500px cursor-pointer"
                  ></svg>
                </div>
              </div>
            </div>

            <div>
              <div class="bg-f4f5f6 px-2 py-4 flex items-center rounded-lg">
                <div class="w-1/4 text-center">
                  <h1 class="font-bold text-primary mb-0 text-2xl">
                    {{
                      eventsCard[0].eventDate
                        ? new Date(eventsCard[0].eventDate).getDate()
                        : ""
                    }}
                  </h1>
                  <p class="fsize14 font-normal font-semibold text-primary">
                    {{
                      eventsCard[0].eventDate
                        ? month[new Date(eventsCard[0].eventDate).getMonth()]
                        : ""
                    }}
                  </p>
                </div>
                <h1 class="text-gray mb-0 fsize12 w-3/4 pl-2">
                  {{ eventsCard[0] ? eventsCard[0].eventTitle : "" }}
                </h1>
              </div>
            </div>
          </div>
          <div class="px-4 pb-4 pt-2" v-if="!Posts">
            <vs-button color="primary" class="fsize14 w-full" @click="OpenEdit"
              >Create Post</vs-button
            >
          </div>
          <div v-else>
            <div class="flex pt-8 justify-end gap-4">
              <vs-button
                color="primary"
                class="fsize14 w-full rounded-full"
                @click="OpenEdit"
                >Edit</vs-button
              >
              <vs-button
                color="success"
                @click="shareImage(Posts)"
                class="fsize14 w-full rounded-full"
                >Download</vs-button
              >
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { CampaignStatuslogic } from "./CampaignStatuslogic";
import EditCompVue from "../../branding/components/EditComp.vue";

export default {
  components: {
    EditComp: EditCompVue,
  },
  methods: {
    OpenEdit() {
      this.isShowContentEdit = true;
    },
  },
  name: "CampaignStatus",
  mixins: [CampaignStatuslogic],
};
</script>

<style>
.bradgall .el-dialog__body {
  padding: 25px 0px 0px 0px;
}
</style>
